export const integrationHealthIsoStateIds = {
  TotalCountTable: `integration-health-total-count-table`,
  IntegrationCard: `integration-health-integration-card`,
  SyncRatioTable: `integration-health-sync-ratio-table`,
  TeamProfileIntegrationList: `team-profile-integration-list`,
  IntegrationHealthTable: `integration-health-table`,
  IntegrationHealthCalendar: `integration-health-calendar`,
};
